import {
  Component,
  input,
  InputSignal
} from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import {
  ButtonComponent,
  ModalCloseDirective,
  ModalHeaderButtonsComponent,
  ModalHeaderCloseButtonComponent,
  ModalHeaderComponent,
  ModalHeaderTitleComponent,
  ModalPanelComponent,
  PageActionPanelComponent,
  StickyPanelBottomComponent,
  StickyPanelBottomContentComponent
} from '@tdwb/core';
import { Agreement } from '@tdwb/lazy/platform/preferences';
import { FplTermsAndConditionsComponent } from '@tdwb/webbroker/core';
import { AmexAgreementComponent } from '../../agreements/current-agreements/amex-agreement.component';
import { CegAgreementComponent } from '../../agreements/current-agreements/ceg-agreement.component';
import { CmeAgreementComponent } from '../../agreements/current-agreements/cme-agreement.component';
import { IexAgreementComponent } from '../../agreements/current-agreements/iex-agreement.component';
import { MeAgreementComponent } from '../../agreements/current-agreements/me-agreement.component';
import { NasdaqAgreementComponent } from '../../agreements/current-agreements/nasdaq-agreement.component';
import { NyseAgreementComponent } from '../../agreements/current-agreements/nyse-agreement.component';
import { OpraAgreementComponent } from '../../agreements/current-agreements/opra-agreement.component';
import { RusselAgreementComponent } from '../../agreements/current-agreements/russel-agreement.component';
import { TdAgreementComponent } from '../../agreements/current-agreements/td-agreement.component';
import { UsotcAgreementComponent } from '../../agreements/current-agreements/usotc-agreement.component';

@Component({
  selector: 'td-wb-consolidated-exchange-agreements-modal',
  templateUrl: 'consolidated-agreements.modal.component.html',
  styleUrls: ['consolidated-agreements.modal.component.scss'],
  imports: [
    ButtonComponent,
    FplTermsAndConditionsComponent,
    ModalCloseDirective,
    ModalHeaderButtonsComponent,
    ModalHeaderCloseButtonComponent,
    ModalHeaderComponent,
    ModalHeaderTitleComponent,
    ModalPanelComponent,
    PageActionPanelComponent,
    StickyPanelBottomComponent,
    StickyPanelBottomContentComponent,
    TranslateDirective,
    AmexAgreementComponent,
    CegAgreementComponent,
    CmeAgreementComponent,
    IexAgreementComponent,
    MeAgreementComponent,
    NasdaqAgreementComponent,
    NyseAgreementComponent,
    OpraAgreementComponent,
    RusselAgreementComponent,
    TdAgreementComponent,
    UsotcAgreementComponent
  ]
})
export class ConsolidatedAgreementsModalComponent {
  readonly agreement: InputSignal<Agreement | undefined> = input<Agreement | undefined>(undefined, {
    alias: 'agreement'
  });

  isDisabled(): boolean {
    return this.agreement()?.agreementStatus === 'ACCEPTED';
  }
}
